export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_FORTNOXSUPPLIERINVOICE",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_FORTNOXSUPPLIERINVOICE",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_FORTNOXSUPPLIERINVOICE",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_FORTNOXSUPPLIERINVOICE",
  DESTROY_FORM: "DESTROY_FORM_FORTNOXSUPPLIERINVOICE",
  SET_FORM_ERROR: "SET_FORM_ERROR_FORTNOXSUPPLIERINVOICE",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_FORTNOXSUPPLIERINVOICE",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_FORTNOXSUPPLIERINVOICE",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_FORTNOXSUPPLIERINVOICE",
  RESET_STATE: "RESET_STATE_FORTNOXSUPPLIERINVOICE",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_FORTNOXSUPPLIERINVOICE",
  REMOVE_OBJECT: "REMOVE_OBJECT_FORTNOXSUPPLIERINVOICE",
  SET_EXPECTED_INVOICE_STAT: "SET_EXPECTED_INVOICE_STAT_FORTNOXTRANSACTION",
  CLEAR_FETCHED: "CLEAR_FETCHED_FORTNOXSUPPLIERINVOICE",

  LIST_URL: "/accounting/fortnox/fortnoxsuppliererrandinvoice/list/",
  POST_URL: "/accounting/fortnox/fortnoxsuppliererrandinvoice/",
  PATCH_URL: "/accounting/fortnox/fortnoxsuppliererrandinvoice/",
  GET_URL: "/accounting/fortnox/fortnoxsuppliererrandinvoice/",

  STORE_NAME: "fortnoxSupplierInvoice",
};
